export default "__VITE_PUBLIC_ASSET__1c311678__"